import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const useDocumentoSpf = () => {
  const [docParams, setDocParams] = useState({ sqAberturaProcesso: null });
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  useEffect(() => {
    if (docParams?.sqAberturaProcesso) {
      const values = docParams;
      requestDocumento(apiRoutes.fiscalizacao.procedimentoFiscal.documentoHtml, values);
    }
  }, [requestDocumento, docParams]);

  useEffect(() => {
    let win;
    if (dataDocumento?.result) {
      win = window.open("", "", "height=800, width=800");
      win.document.write(dataDocumento.result);
      win.document.close();
      // win.setTimeout(win.print, 1000);
    }
  }, [dataDocumento]);

  const documentoPrint = () => {};

  return { documentoPrint, setDocParams };
};

export default useDocumentoSpf;
